<template>
  <div class="file-pres bordered">
    <div class="file-pres__main">
      <div class="file-pres__icon">
        <span class="ns-icon-ico020 ns-large-icon">
            <span class="path1"></span>
            <span class="path2"></span>
          </span>
      </div>

      <text-string label-id="txt327"/>

      <smd-spacer/>
      <span class="file-pres__change Hyperlink3"
            @click.prevent.stop="remove">
      Remove
      </span>
    </div>

    <div class="file-pres__other"
         :class="{'m-t-20': !getAllListedItems}">
      <smd-textarea placeholder="Enter which items you’d like to get*"
                    v-if="!getAllListedItems"
                    @input="updateRemarks"/>
      <div class="smd-checkbox__row m-t-10 m-l-50 m-b-5">
        <smd-checkbox label="Get all listed items"
                      :model-value="getAllListedItems"
                      @change="changeCheckboxValue"/>
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from 'lodash/debounce';

  export default {
    name: "file-pres-added-attached",
    props: {
      getAllListedItems: {type: Boolean, default: true},
      index: {type: Number},
      item: {type: Object}
    },
    methods: {
      changeCheckboxValue() {
        this.$emit('change-checkbox', this.index, !this.item.partial, '');
      },
      remove() {
        this.$emit('remove', this.index);
      },
      updateRemarks: debounce(function (remarks) {
        this.$emit('update-remarks', this.index, this.item.partial, remarks)
      }, 450),
    }
  }
</script>

<style lang="scss">

</style>